export default class ApplicationError extends Error {
  constructor(message, details) {
    super(message)

    Object.assign(this, details)
  }
}
